import { uniqBy } from "es-toolkit/compat";
import { type FC, useMemo } from "react";

import { InfoBox } from "@/components/InfoBox";
import { MotifIcon } from "@/components/MotifIcon";
import { Trans } from "@/features/i18n/Trans";
import type { InterludeTypes } from "@/interlude";

/**
 * Design:
 * [Figma](https://www.figma.com/design/k0XwP83RAV16nVdyFx7crb/Omnichannel?node-id=6781-38598&m=dev)
 */
export const UnifyScope: FC<{ orgs: Array<InterludeTypes["Org"]> }> = ({
  orgs,
}) => {
  const notMergingWithOtherOrgs = useMemo(
    function computeIsMergingWithOtherOrgs() {
      return uniqBy(orgs, "uuid").length === 1;
    },
    [orgs],
  );

  const scopes = useMemo(
    function computeScopes() {
      return orgs
        .map((org) => `${org.source.toUpperCase()} ${org.name}`)
        .join(", ");
    },
    [orgs],
  );

  if (notMergingWithOtherOrgs) return null;

  return (
    <InfoBox
      variant="warning"
      icon={<MotifIcon un-i-motif="circle_info" />}
      description={
        <Trans
          i18nKey="feature.profileUnification.warning"
          values={{
            scopes: scopes,
          }}
          components={{
            strong: <strong />,
          }}
        />
      }
    />
  );
};
